import React from "react";

import "./EducationTwoCategory.scss";

const EducationTwoCategory = () => {
  return (
    <section className="et_category sect_padding">
      <div className="container">
        <div className="sect_header">
          <span className="sect_badge">CATEGORIES</span>
          <h3 className="sect_title d-flex justify-content-between">
          <div className="h3_inner">
          Browse By{" "}
            <span className="relative">
            Categories
              <span class="title-shape">
                <svg
                  width="150"
                  height="65"
                  viewBox="0 0 168 65"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="highligt_text"
                >
                  <path
                    d="M73.3761 8.49147C78.4841 6.01353 82.5722 4.25154 88.8933 3.3035C94.2064 2.50664 99.6305 2.0701 104.981 1.94026C120.426 1.56549 135.132 4.90121 146.506 9.70405C158.628 14.8228 166.725 22.5638 166.074 31.6501C165.291 42.5779 151.346 51.7039 133.508 56.8189C110.253 63.4874 81.7065 63.8025 58.5605 60.8285C37.5033 58.123 11.6304 51.7165 3.58132 40.0216C-3.43085 29.8337 12.0728 18.1578 27.544 11.645C40.3656 6.24763 55.7082 2.98328 70.8043 4.08403C81.9391 4.89596 93.2164 6.87822 102.462 9.99561C112.874 13.5066 120.141 18.5932 127.862 23.6332"
                    stroke="var(--click-color)"
                    stroke-width="3"
                    stroke-linecap="round"
                  ></path>
                </svg>
              </span>
            </span>
          </div>
            <div className="theme_btn btn_fill with_icon">
             All Categories
                    <span class="material-symbols-outlined">
                      arrow_right_alt
                    </span>
                  </div>
          </h3>
        </div>
        <div className="category_cards">
            <div className="cc_single">
                <div className="ccs_inner">
                    <div className="icon">
                        <div className="icon_inner">                           
                                <img src="./assets/img/educationtwo/icons/ct-1.png" alt="" />                           
                        </div>
                    </div>
                    <h5>
                        Academic Tutions
                    </h5>
                    <h6>
                        25 Courses 
                    </h6>
                </div>
            </div>
            <div className="cc_single">
                <div className="ccs_inner">
                    <div className="icon">
                        <div className="icon_inner">                           
                                <img src="./assets/img/educationtwo/icons/ct-2.png" alt="" />                           
                        </div>
                    </div>
                    <h5>
                        Competitive Exams
                    </h5>
                    <h6>
                        25 Courses 
                    </h6>
                </div>
            </div>
            <div className="cc_single">
                <div className="ccs_inner">
                    <div className="icon">
                        <div className="icon_inner">                           
                                <img src="./assets/img/educationtwo/icons/ct-3.png" alt="" />                           
                        </div>
                    </div>
                    <h5>
                        Hobby & Creative Classes
                    </h5>
                    <h6>
                        25 Courses 
                    </h6>
                </div>
            </div>
            <div className="cc_single">
                <div className="ccs_inner">
                    <div className="icon">
                        <div className="icon_inner">                           
                                <img src="./assets/img/educationtwo/icons/ct-4.png" alt="" />                           
                        </div>
                    </div>
                    <h5>
                        Kids Institutes/Daycare
                    </h5>
                    <h6>
                        25 Courses 
                    </h6>
                </div>
            </div>
            <div className="cc_single">
                <div className="ccs_inner">
                    <div className="icon">
                        <div className="icon_inner">                           
                                <img src="./assets/img/educationtwo/icons/ct-5.png" alt="" />                           
                        </div>
                    </div>
                    <h5>
                        Languages
                    </h5>
                    <h6>
                        25 Courses 
                    </h6>
                </div>
            </div>
            <div className="cc_single">
                <div className="ccs_inner">
                    <div className="icon">
                        <div className="icon_inner">                           
                                <img src="./assets/img/educationtwo/icons/ct-6.png" alt="" />                           
                        </div>
                    </div>
                    <h5>
                        Music & Dance
                    </h5>
                    <h6>
                        25 Courses 
                    </h6>
                </div>
            </div>
            <div className="cc_single">
                <div className="ccs_inner">
                    <div className="icon">
                        <div className="icon_inner">                           
                                <img src="./assets/img/educationtwo/icons/ct-7.png" alt="" />                           
                        </div>
                    </div>
                    <h5>
                        Sports And Fitness
                    </h5>
                    <h6>
                        25 Courses 
                    </h6>
                </div>
            </div>
            <div className="cc_single">
                <div className="ccs_inner">
                    <div className="icon">
                        <div className="icon_inner">                           
                                <img src="./assets/img/educationtwo/icons/ct-8.png" alt="" />                           
                        </div>
                    </div>
                    <h5>
                        Special Needs Educators
                    </h5>
                    <h6>
                        25 Courses 
                    </h6>
                </div>
            </div>
            
        </div>
      </div>
    </section>
  );
};

export default EducationTwoCategory;
